// JavaScript Document
"use strict";
var Pace = {
    // All Functions
    init: function() {
        console.log('init pace');
        jQuery(window).resize(function() {
            Pace.loadResize();
            Pace.stickImage();
        });

        jQuery(window).scroll(function() {
            Pace.stickyheader();
        });

        Pace.fullpage();
        Pace.arrowscroll();
        Pace.stickyheader();

        Pace.navigation();
        Pace.navclick();
        Pace.gastroCarousal();
        Pace.openGallery();
        Pace.teamDDL();
        // Pace.teamMemberDetail();
        // Pace.teamMemberDetailClose();
        // Pace.eventsMemberTeam();
        // Pace.curryWurstMemberTeam();
        Pace.careerCarousal();
        Pace.eventCarousal();
        Pace.careerDreamCarousal();
        //Pace.stickImage();
        Pace.eventsSlickSliderActions();
        Pace.scrollMagicCircleAnimation();

        Pace.masonryGrid();

        Pace.lightboxImageViewer();


        // console.log('init smartmenus');
        // $('#main-menu-visible').smartmenus();

    },

    stickImage: function() {
        $(window).scroll(function() {
            if ($(window).width() >= 768) {
                var windowpos = $(window).scrollTop();
                $(".scroll-div").each(function() {
                    var currTop = $(this).offset().top;

                    var parent = $(this).closest('.scroll-parent');
                    var currMovingDiv = parent.offset().top;

                    var currMovingDivH = $(this).outerHeight(true);

                    var stickE = $(this).closest('.scroll-parent').find('.vertical-headline');
                    var stickEH = stickE.outerHeight(true);

                    var topF = currMovingDiv == 0 ? currTop : currMovingDiv;
                    var heightF = currMovingDivH;

                    var currBottom = topF + heightF;

                    if (currMovingDivH > stickEH) {
                        if (windowpos >= (currTop - 100) & windowpos <= (currBottom - 100)) {
                            stickE.addClass("stick");
                        } else {
                            stickE.removeClass("stick");
                        }
                    }
                });
            }


        });
    },


    /************ Banner Section start *************/
    stickyheader: function() {

        if ($(window).scrollTop() >= 50) {
            $('.header').addClass('fixed-header');
        } else {
            $('.header').removeClass('fixed-header');
        }
    },


    loadResize: function() {
        Pace.arrowscroll();
    },

    arrowscroll: function() {
        var bannerHeight = jQuery(window).outerHeight();
        jQuery('.animation-scroll').on('click', function() {
            jQuery("html, body").animate({
                scrollTop: bannerHeight
            }, 300);
            return false;
        });
    },
    /************ Banner Section ends *************/


    fullpage: function() {
        if ($("#fullpage").length) {
            var myFullpage = new fullpage('#fullpage', {
                navigation: false,
                responsiveWidth: 900,
                afterResponsive: function(isResponsive) {}
            });
        }
    },

    navigation: function() {
        $(".nav-bar").on("click", function(e) {
            console.log('Clicked!');
            $(".nav-layer").toggleClass("navbar-opened");
            if ($(".nav-layer").hasClass("navbar-opened")) {
                $(".nav-layer").css('display', 'block');
                $("body").addClass('overflow-none')
            } else {
                $("body").removeClass('overflow-none')
                $(".nav-layer").css('display', 'none');
            }
        });
    },

    navclick: function() {
        $("nav > div > ul > li > a").on("click mouseover", function() {
            if ($(this).next().hasClass("sub-menu")) {
                $("nav > div > ul > li").removeClass("active");
                $(this).parent().addClass("active");
            }
        });
    },

    gastroCarousal: function() {
        $('.gastro-carousel').slick({
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            dots: true,
            arrows: false,
            centerMode: true,
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    // centerMode: true,

                }

            }, {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: true,
                    infinite: true,

                }
            }, {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 2000,
                }
            }]
        });
    },

    careerCarousal: function() {
        $('.career-gallery').slick({
            dots: true,
            arrows: false,
            infinite: true,
            autoplay: true,
        });
    },

    eventCarousal: function() {
        $('.event-nav-menu').slick({
            autoplaySpeed: 5500,
            slidesToShow: 6,
            dots: false,
            arrows: false,
            infinite: true,
            autoplay: true,
            variableWidth: true,
            centerMode: true,
            focusOnSelect: true,
            speed: 500,
            asNavFor: '.event-details'
        });
        $('.event-details').slick({
            autoplaySpeed: 5500,
            slidesToShow: 1,
            dots: false,
            arrows: false,
            infinite: true,
            autoplay: true,
            adaptiveHeight: true,
            fade: true,
            speed: 500,
            cssEase: 'ease-in-out',
            touchThreshold: 100,
            asNavFor: '.event-nav-menu'
        });
    },

    eventCarouselTrigger: function() {
        $('.event-details').on('afterChange', function(event, slick, currentSlide, nextSlide){
            var dataId = $(slick.$slides[currentSlide]).data('index');  
            $('.content').hide();
            $('.content[data-id=' + dataId + ']').show();    
        });
    },

    eventsSlickSliderActions: function() {

        var ajaxurl = "/wp/wp-admin/admin-ajax.php";
        var play = true;
        var buttonText, format_id, hash, $button, posts_list, activeSlide;
        var language = $("body").data('language') ? $("body").data('language') : 'de';

        // Set navigation to hash value (if existent):
        var hash = window.location.hash;
        hash = hash.substring(1, hash.length);
        // console.log('hash: ' + hash);
        if (hash) {
            activeSlide = $(".event-nav-menu div").find("[data-hash='" + hash + "']").data('slide');
            $('.event-nav-menu').slick('slickGoTo', activeSlide, true);
            $('.event-nav-menu').slick('slickPause');
            $('.event-details').slick('slickPause');

            // Load references, when hash is set:
            // Get format_id:
            var currentFormat = $(".event-nav-menu div").find("[data-hash='" + hash + "']").data('id');

            $.ajax({
                url: ajaxurl,
                type: 'post',
                data: {
                    action: 'load_event_references',
                    format_id: currentFormat,
                    language: language
                },
                success: function(result) {
                    if(result.success != false) {
                        // console.log(result);
                        var posts_list = document.querySelector('.reference-list');
                        posts_list.innerHTML = result.data;

                        var $activeButton = $(".slick-button.load-event-references[data-format-id=" + currentFormat + "]");
                        $activeButton.text('Unset reference filter');
                        $activeButton.hide();

                    }
                }
            });

        }

        // Preset BG color:
        var activeNav = activeSlide ? $(".event-nav-menu div").find("[data-slide=" + activeSlide + "]") : $(".event-nav-menu div").find("[data-slide=0]");
        var color = activeNav.data('color') ? activeNav.data('color') : '#FFB200';
        $('#event-bg').css('background-color', color);

        // Reset BG color to format setting:
        $('.event-nav-menu').on('afterChange', function(event, slick, currentSlide, nextSlide) {

            var activeNav = $(".event-nav-menu div").find("[data-slide=" + currentSlide + "]");
            var color = activeNav.data('color') ? activeNav.data('color') : '#FFB200';
            $('#event-bg').css('background-color', color);

            // Reset all "Load Buttons"
            $('.load-event-references').show();

            // Reset reference list
            posts_list = document.querySelector('.reference-list');
            posts_list.innerHTML = '';

            play = true;

        });

        if ( $('.load-event-references') ) {
            $('.load-event-references').on('click', function( event ) {
                event.preventDefault();
                console.log('load-event-references clicked 1');
                if (play) {
                    $button = $(this);
                    buttonText = $button.text();
                    format_id = $button.data('format-id');
                    hash = $button.data('hash');
                    play = false;
                    $('.event-nav-menu').slick('slickPause');
                    $('.event-details').slick('slickPause');
                    $(this).text('Loading...');
                    $('.reference-list').innerHTML = '';

                    window.location.hash = hash;

                    // Load references with Ajax call:
                    $.ajax({
                        url: ajaxurl,
                        type: 'post',
                        data: {
                            action: 'load_event_references',
                            format_id: format_id,
                            language: language
                        },
                        success: function(result) {
                            if(result.success != false) {
                                // console.log(result);
                                var posts_list = document.querySelector('.reference-list');
                                posts_list.innerHTML = result.data;
                                // $button.text('Unset reference filter');

                                var scrollTo = $button.offset().top - 100;
                                console.log( scrollTo );

                                $button.text(buttonText);
                                $button.hide();

                                jQuery("html, body").animate({
                                    scrollTop: scrollTo
                                }, 300);

                            } else {
                                // console.log(result.data);
                                var posts_list = document.querySelector('.reference-list');
                                posts_list.innerHTML = '<p style="padding-left: 22px;">Nichts gefunden</p>';

                                // var $message = $("document p.message").find("[data-format-id=" + format_id + "]");
                                // $message.innerHTML = result.data;

                                jQuery("html, body").animate({
                                    scrollTop: 0
                                }, 300);
                                play = true;
                                $('.event-nav-menu').slick('slickPlay');
                                $button.text(buttonText);
                                $button.hide();
                            }
                        },
                        error: function(result) {
                            // console.log(result.data);
                            var posts_list = document.querySelector('.reference-list');
                            posts_list.innerHTML = '';

                            jQuery("html, body").animate({
                                scrollTop: 0
                            }, 300);
                            play = true;
                            $('.event-nav-menu').slick('slickPlay');
                            $button.text(buttonText);
                        }
                    });

                } else {
                    jQuery("html, body").animate({
                        scrollTop: 0
                    }, 300);
                    play = true;
                    $('.event-nav-menu').slick('slickPlay');
                    $button.text(buttonText);
                }
            });
        }
    },

    careerDreamCarousal: function() {
        $('.career-dream-gallery').slick({
            speed: 500,
            dots: true,
            arrows: true,
            infinite: true,
            autoplay: true,
            responsive: [{
                breakpoint: 600,
                settings: {
                    arrows: false
                }
            }]
        });
    },

    openGallery: function() {
        var container = [];
        $('.galleryGrid').find('figure').each(function() {
            var $link = $(this).find('a'),
                item = {
                    src: $link.attr('href'),
                    w: $link.data('width'),
                    h: $link.data('height'),
                    title: $link.data('caption')
                };
            container.push(item);
        });
        // Define click event on gallery item
        $('.galleryGrid figure > a').click(function(event) {
            // Prevent location change
            event.preventDefault();
            console.log('clicked');
            // Define object and gallery options
            var $pswp = $('.pswp')[0],
                options = {
                    index: $(this).parent('figure').index(),
                    bgOpacity: 0.55,
                    showHideOpacity: true,
                    shareEl: false,

                };
            // Initialize PhotoSwipe
            var gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, container, options);
            gallery.init();
        });
    },

    lightboxImageViewer: function() {

        $('body').find('.lightbox').each(function() {
            var img = $(this).find('img');
            img.addClass('lightbox');
        });

        var image = '<div class="mySlides"><div class="numbertext">{{NUMBER}}</div><img src="{{IMAGE}}" style="width:100%" alt="{{ALT}}" data-image-id="{{ID}}"></div>';
        var end = '<a class="prev">&#10094;</a><a class="next">&#10095;</a>';
        var images = '<div class="caption-container"><p id="caption"></p></div>';
        var tmp = '';
        var count = 1;
        $('body').find('img.lightbox').each(function() {
            $(this).attr('data-image-id', count);
            tmp = image;
            tmp = tmp.replace('{{NUMBER}}', count);
            tmp = tmp.replace('{{IMAGE}}', $(this).attr('src'));
            tmp = tmp.replace('{{ALT}}', $(this).attr('alt'));
            tmp = tmp.replace('{{ID}}', count);
            images += tmp;
            count++;
        });
        images += end;

        var modalImages = document.querySelector('#lightboxModal .modal-content');
        modalImages.innerHTML = images;

        var slideIndex = 1;

        if( count > 1) {
            $('img.lightbox').on('click', function() {
                slideIndex = $(this).attr('data-image-id');
                document.getElementById("lightboxModal").style.display = "block";
                showSlides(slideIndex);
                console.log('lightbox image clicked');
            });
            $('#lightboxModal .close').on('click', function() {
                document.getElementById("lightboxModal").style.display = "none";
            });

            $('#lightboxModal .prev').on('click', function() {
                showSlides(slideIndex += -1);
            });
            $('#lightboxModal .next').on('click', function() {
                showSlides(slideIndex += 1);
            });

        }

        function showSlides(n) {
            var i;
            var slides = document.getElementsByClassName("mySlides");
            var captionText = document.getElementById("caption");
            if (n > slides.length) {slideIndex = 1}
            if (n < 1) {slideIndex = slides.length}
            for (i = 0; i < slides.length; i++) {
                slides[i].style.display = "none";
            }
            slides[slideIndex-1].style.display = "block";
            var imageDiv = slides[slideIndex-1];
            var alt = $('.mySlides img[data-image-id=' + slideIndex + ']').attr('alt');
            console.log(slideIndex, alt);
            captionText.innerHTML = alt;
        }

    },

    teamDDL: function() {
        $('.team-btns .dropdown-menu a').on('click', function() {
            $('#dropdownMenuLink').text($(this).text());
        });
    },

    eventsMemberTeam: function() {
        $('#eventsMember').on('click', function() {
            $("#allMembersList").hide();
            $("#curryWurstMembersList").hide();
            $("#eventMembersList").show();
        });
    },

    curryWurstMemberTeam: function() {
        $('#curryWurstMember').on('click', function() {
            $(this).addClass("active");
            $("#eventMembersList").hide();
            $("#allMembersList").hide();
            $("#curryWurstMembersList").show();
        });
    },

    scrollMagicCircleAnimation: function() {

        if ($('#scrollMagicCircleAnimation').length > 0) {

            //1st animation : Large to small circle
            // Init ScrollMagic Controller
            var scrollMagicController = new ScrollMagic.Controller();

            // Create Animation for 2.5s
            var tween1 = TweenMax.to('#animation1', 2.5, {
                // scale: 0.3,
            });

            // Create the Scene and trigger when visible
            var scene1 = new ScrollMagic.Scene({
                    triggerElement: '#scene1',
                    offset: 0,
                    /* offset the trigger 150px below #scene's top */
                    duration: 300
                })
                .setTween(tween1)
                .addTo(scrollMagicController);

            // Add debug indicators fixed on right side
            //   scene1.addIndicators({name: "1 (duration: 300)"});

            //2nd animation : Small circle color change
            var tween2 = TweenMax.to('#animation1', 0.5, {
                backgroundColor: 'rgb(12, 227, 255)',
                scale: 0.3
            });

            var scene2 = new ScrollMagic.Scene({
                    triggerElement: '#scene1',
                    offset: 570,
                    // duration: 400
                })
                // .setPin("#animation1")
                .setTween(tween2)
                .addTo(scrollMagicController);

            //  scene2.addIndicators({name: "2 (duration: 0)"});

            //3rd animation : sky circle sticky
            var tween3 = TweenMax.to('#animation1', 2.5, {
                // translateY: 50
            });

            var scene3 = new ScrollMagic.Scene({
                    triggerElement: '#scene1',
                    offset: 575,
                    duration: 350
                })
                .setPin("#animation1")
                .setTween(tween3)
                .addTo(scrollMagicController);

            //   scene3.addIndicators({name: "sky fix (duration: 350)"});

            //2nd animation - green circle
            var opacitytween4 = TweenMax.to('#animation2', 2.5, {
                opacity: 0
            });

            var opacityscene4 = new ScrollMagic.Scene({
                    triggerElement: '#scene1',
                    offset: 0,
                    duration: 590
                })
                .setTween(opacitytween4)
                .addTo(scrollMagicController);

            //  opacityscene4.addIndicators({name: "4opac (duration: 590)"});

            var tween4 = TweenMax.to('#animation2', 0.5, {
                scale: 0.3,
                opacity: 0
            });

            var scene4 = new ScrollMagic.Scene({
                    triggerElement: '#scene1',
                    offset: 570,
                })
                .setTween(tween4)
                .addTo(scrollMagicController);


            var stickytween4 = TweenMax.to('#animation2', 2.5, {

            });

            var stickyscene4 = new ScrollMagic.Scene({
                    triggerElement: '#scene1',
                    offset: 575,
                    duration: 350
                })
                .setPin("#animation2")
                .setTween(stickytween4)
                .addTo(scrollMagicController);

            // stickyscene4.addIndicators({name: "green fix (duration: 350)"});

            var tween6 = TweenMax.to('#animation2', 0.5, {
                translateX: -20,
            });
            var scene6 = new ScrollMagic.Scene({
                    triggerElement: '#scene1',
                    offset: 590,
                    duration: 50
                })
                .setTween(tween6)
                .addTo(scrollMagicController);
            // scene6.addIndicators({name: "6 (duration: 590)"});

            var tween7 = TweenMax.to('#animation2', 2.5, {
                opacity: 0.7,
                translateX: -220,
            });

            var scene7 = new ScrollMagic.Scene({
                    triggerElement: '#scene1',
                    offset: 700,
                    duration: 150
                })
                .setTween(tween7)
                .addTo(scrollMagicController);

            //  scene7.addIndicators({name: "Green Visible (duration: 150)"});


            //animation3 - pink circle
            var opacitytween8 = TweenMax.to('#animation3', 2.5, {
                opacity: 0
            });

            var opacityscene8 = new ScrollMagic.Scene({
                    triggerElement: '#scene1',
                    offset: 0,
                    duration: 590
                    // duration: 400
                })
                .setTween(opacitytween8)
                .addTo(scrollMagicController);

            //  opacityscene8.addIndicators({name: "4opac (duration: 590)"});

            var tween8 = TweenMax.to('#animation3', 0.5, {
                scale: 0.3,
                opacity: 0
            });

            var scene8 = new ScrollMagic.Scene({
                    triggerElement: '#scene1',
                    offset: 570,
                })
                .setTween(tween8)
                .addTo(scrollMagicController);

            var stickytween8 = TweenMax.to('#animation3', 2.5, {

            });

            var stickyscene4 = new ScrollMagic.Scene({
                    triggerElement: '#scene1',
                    offset: 575,
                    duration: 350
                })
                .setPin("#animation3")
                .setTween(stickytween8)
                .addTo(scrollMagicController);

            //   scene8.addIndicators({name: "pink fix (duration: 350)"});

            var tween9 = TweenMax.to('#animation3', 0.5, {
                translateX: -20,
            });
            var scene9 = new ScrollMagic.Scene({
                    triggerElement: '#scene1',
                    offset: 590,
                    duration: 50
                })
                .setTween(tween9)
                .addTo(scrollMagicController);

            var tween10 = TweenMax.to('#animation3', 2.5, {
                opacity: 0.7,
                translateX: 220,
            });

            var scene10 = new ScrollMagic.Scene({
                    triggerElement: '#scene1',
                    offset: 700,
                    duration: 150
                })
                .setTween(tween10)
                .addTo(scrollMagicController);

            //  scene10.addIndicators({name: "Pink Visible (duration: 150)"});


            //4th animation - Text appear
            var tweentext = TweenMax.to('#animation4', 0.5, {});

            var scenetext = new ScrollMagic.Scene({
                    triggerElement: '#scene2',
                    offset: 900,
                    duration: 400
                })
                .setClassToggle('.circle-title', "visible")
                .setTween(tweentext)
                .addTo(scrollMagicController);
            // scenetext.addIndicators({name: "Title (duration: 400)"});

            //5th animation - Green circle remove
            var tween11 = TweenMax.to('#animation2', 0.5, {
                opacity: 0
            });

            var scene11 = new ScrollMagic.Scene({
                    triggerElement: '#scene1',
                    offset: 1300,
                    duration: 100
                })
                .setTween(tween11)
                .addTo(scrollMagicController);
            //  scene11.addIndicators({name: "9 (duration: 100)"});

            //6th animation : green circle move to section
            var tween12 = TweenMax.to('#animation2', 2.5, {
                opacity: 1,
                translateX: -63,
                translateY: 1056
            });

            var scene12 = new ScrollMagic.Scene({
                    triggerElement: '#scene2',
                    offset: 1350,
                    duration: 400
                })
                .setTween(tween12)
                .addTo(scrollMagicController);
            //   scene12.addIndicators({name: "10 (duration: 400)"});


            //7th animation : sky circle remove
            var tween13 = TweenMax.to('#animation1', 2.5, {
                opacity: 0
            });

            var scene13 = new ScrollMagic.Scene({
                    triggerElement: '#scene1',
                    offset: 1450,
                    duration: 100
                })
                .setTween(tween13)
                .addTo(scrollMagicController);
            //  scene13.addIndicators({name: "11 (duration: 100)"});

            //8th animation : sky circle move to section
            var tween14 = TweenMax.to('#animation1', 2.5, {
                opacity: 1,
                translateX: -68,
                translateY: 1850
            });

            var scene14 = new ScrollMagic.Scene({
                    triggerElement: '#scene1',
                    offset: 1950,
                    duration: 600
                })
                .setTween(tween14)
                .addTo(scrollMagicController);
            //  scene14.addIndicators({name: "12 (duration: 600)"});

            //9th animation : pink circle remove
            var tween15 = TweenMax.to('#animation3', 2.5, {
                opacity: 0
            });

            var scene15 = new ScrollMagic.Scene({
                    triggerElement: '#scene1',
                    offset: 1550,
                    duration: 100
                })
                .setTween(tween15)
                .addTo(scrollMagicController);
            //   scene15.addIndicators({name: "13 (duration: 100)"});

            //10th animation : pink circle move to section
            var tween16 = TweenMax.to('#animation3', 2.5, {
                opacity: 1,
                translateX: -63,
                translateY: 2952
            });

            var scene16 = new ScrollMagic.Scene({
                    triggerElement: '#scene1',
                    offset: 2580,
                    duration: 800
                })
                .setTween(tween16)
                .addTo(scrollMagicController);
            //    scene16.addIndicators({name: "14 (duration: 300)"});
        }

    },

    masonryGrid: function() {
        if ( $(".galleryGrid").length && $('.galleryImage').length ) {
            var container = document.querySelector(".galleryGrid");
            imagesLoaded(container, function() {
                new Masonry(container, {
                    itemSelector: ".galleryImage",
                    isFitWidth: true
                });
            });
        }
    },

    loadAjax: function( ajaxurl, query, action, current_page, max_pages, selector, language='de', add=false ) {

        // console.log('AJAX CALL ',' current_page ',current_page,' max_pages ',max_pages);

        $.ajax({
            url: ajaxurl,
            type: 'post',
            dataType: 'json',
            data: {
                action: action,
                current_page: current_page,
                max_pages: max_pages,
                query: query,
                language:language,
            },
            success: function(result) {
                // console.log(result.data);
                var posts_list = document.querySelector(selector);
                if (add) {
                    posts_list.innerHTML += result.data;
                } else {
                    posts_list.innerHTML = result.data;
                }
                $(selector).attr('data-page', current_page);

                // console.log('new current_page: ' + current_page);
                maxPages = $('.max-num-pages').attr('data-max-num-pages')-1;

                // console.log('data-page ',$(selector).attr('data-page'),' MaxPages ', maxPages);


                // console.log(maxPages);
                if ( $(selector).attr('data-page') == maxPages || result.data == 'No more posts!') {
                    $('button.load-more.team-page').hide();
                    $('button.load-more.blog-page').hide();
                }
                else {
                    $('button.load-more.team-page').show();
                    $('button.load-more.blog-page').show();
                }
                // current_page++;

            }
        })

    },


    loadBlogAjax: function( ajaxurl, query, action, current_page, max_pages, selector, language='de', add=false ) {

        // console.log('AJAX CALL ',' current_page ',current_page,' max_pages ',max_pages);

        var data = {
            action: action,
            current_page: current_page,
            max_pages: max_pages,
            query: query,
            language:language,
        };
        // console.log('data ->', data);
        $.ajax({
            url: ajaxurl,
            type: 'post',
            dataType: 'json',
            data: data,
            success: function(result) {
                // console.log(result.data);
                var posts_list = document.querySelector(selector);
                if (add) {
                    posts_list.innerHTML += result.data;
                } else {
                    posts_list.innerHTML = result.data;
                }
                $(selector).attr('data-page', current_page);

                // console.log('new current_page: ' + current_page);
                maxPages = $('.max-num-pages').attr('data-max-num-pages')-1;

                // console.log('data-page ',$(selector).attr('data-page'),' MaxPages ', maxPages);


                // console.log(maxPages);
                if ( $(selector).attr('data-page') == maxPages || result.data == 'No more posts!') {
                    $('button.load-more.team-page').hide();
                    $('button.load-more.blog-page').hide();
                }
                else {
                    $('button.load-more.team-page').show();
                    $('button.load-more.blog-page').show();
                }
                // current_page++;

                // Blog specific trigger for masonry effect!
                if( $(window).width() > 768 ) {
                    console.log('success!!');

                    $('.grid').isotope({
                        itemSelector: '.grid-item',
                        percentPosition: true,
                        masonry: {
                            columnWidth: '.grid-item',
                            horizontalOrder: true,
                        }
                    });

                }


            }
        })

    },

};

// when the page is ready, initialize everything
jQuery(document).ready(function() {

    Pace.init();

    jQuery(".search-button-submit").on('click', function() {
        setTimeout(function () {
            jQuery('#search-form').submit();
        }, 0);
    });

    

    const ajaxurl = "/wp/wp-admin/admin-ajax.php";

    // Members popup events // Deactivated! (Just un-comment to re-activate!)
    // $(document).on('click', '.member-thumbnail', function() {
    //     var member = $(this).data('member-id');
    //     console.log('open clicked: ' + member);
    //     $("#" + member).addClass('open');
    //     $("body").addClass('overflow-none');
    // });
    // $(document).on('click', '.member-detail-overlay .close-btn', function() {
    //     console.log('closed clicked');
    //     $(".member-detail-overlay").removeClass('open');
    //     $("body").removeClass('overflow-none');
    // });


    // Posts load and load more, incl. filter states
    var blogFilterSet = {};
    blogFilterSet.categorie = 'Alle Kategorien';

    // Team members load and load more, incl. filter states
    var teamFilterSet = {};
    teamFilterSet.arbeitsbereich = 'all';
    teamFilterSet.haustierbesitzer = 'no';
    teamFilterSet.curry_super = 'none';
    teamFilterSet.spot_wald = 'none';
    teamFilterSet.flasch_champ = 'none';
    teamFilterSet.tat_net = 'none';
    teamFilterSet.sofa_sport = 'none';
    teamFilterSet.zimm_zelt = 'none';
    teamFilterSet.autofahrrad = 'none';

    var button, current_page, max_pages;
    button = document.querySelector('button.team-page');

    if (typeof(button) != 'undefined' && button != null) {

        $('button.load-more.team-page').hide();

        var language = $("body").data('language') ? $("body").data('language') : 'de';

        current_page = document.querySelector('.posts-list').dataset.page;
        max_pages = document.querySelector('.posts-list').dataset.max;

        // Check, if hash was set:
        var hash = window.location.hash;
        hash = hash.substring(1, hash.length);
        // console.log('hash: ' + hash);
        if ( hash ) {
            if ( hash == 'arbeitsbereich-events' ) {
                teamFilterSet.arbeitsbereich = 'Events';
                var $element = $('a.team-filter[data-value=Events]');
                var $parent = $element.parent();
                $parent.find('a').removeClass('active');
                $element.addClass("active");
                $('#dropdownMenuLink').text( 'Events' );
            } else if ( hash == 'area-events' ) {
                teamFilterSet.arbeitsbereich = 'Events';
                var $element = $('a.team-filter[data-value=Events]');
                var $parent = $element.parent();
                $parent.find('a').removeClass('active');
                $element.addClass("active");
                $('#dropdownMenuLink').text( 'Events' );
            }
        }

        // Initial load:
        console.log('loading team members');
        Pace.loadAjax( ajaxurl, teamFilterSet, 'load_team_members', current_page, max_pages, '.posts-list', language );

        $(document).on('click', 'button.team-page', function(e) {

            current_page = document.querySelector('.posts-list').dataset.page;
            // max_pages = document.querySelector('.posts-list').dataset.max;
            max_pages = $('.max-num-pages').attr('data-max-num-pages');

            current_page++;
            // console.log('current_page ',current_page,' max_pages ',$('.max-num-pages').attr('data-max-num-pages') );

            $('.posts-list').attr('data-page', current_page);

            e.preventDefault();
            console.log('load more team members...');

            Pace.loadAjax( ajaxurl, teamFilterSet, 'load_team_members', current_page, max_pages, '.posts-list', language, true );

        });
    }

    // Team members metadata filter
    var teamFilter = $('a.team-filter');
    if ( teamFilter.length && typeof(teamFilter) != 'undefined' && teamFilter != null ) {
        $(document).on('click', 'a.team-filter', function(e) {
            e.preventDefault();

            $('button.load-more.team-page').hide();

            var posts_list = document.querySelector('.posts-list');
            posts_list.innerHTML = 'Load team members...';
            $('.posts-list').attr('data-page', 0);

            current_page = $('.posts-list').attr('data-page');
            max_pages = $('.max-num-pages').attr('data-max-num-pages');

            // 1. Handle the button states:
            var isActive = $(this).hasClass('active');
            var $parent = $(this).parent();
            $parent.find('a').removeClass('active');
            if( !isActive ) {
                $(this).addClass("active");
            }

            // 2. Handle the associated filter states
            var filterType = $(this).data('filter-type');
            var filterValue = $(this).data('value');

            if( filterType == 'arbeitsbereich' ) {
                if( teamFilterSet[filterType] == filterValue ) {
                    teamFilterSet[filterType] = 'all';
                } else {
                    teamFilterSet[filterType] = filterValue;
                }
            } else if( filterType == 'haustierbesitzer' ) {
                if( teamFilterSet[filterType] == filterValue ) {
                    teamFilterSet[filterType] = 'no';
                } else {
                    teamFilterSet[filterType] = 'Ja';
                }
            } else {
                if( teamFilterSet[filterType] == filterValue ) {
                    teamFilterSet[filterType] = 'none';
                } else {
                    teamFilterSet[filterType] = filterValue;
                }
            }

            // console.log(teamFilterSet);
            Pace.loadAjax( ajaxurl, teamFilterSet, 'load_team_members', current_page, max_pages, '.posts-list', language );

        });

    }

    // Blog filter
    var blogFilter = $('a.blog-filter');
    if ( blogFilter.length && typeof(blogFilter) != 'undefined' && blogFilter != null ) {

        $('button.load-more.blog-page').hide();
        $('.posts-list').attr('data-page', 0);
        var language = $("body").data('language') ? $("body").data('language') : 'de';

        current_page = document.querySelector('.posts-list').dataset.page;
        max_pages = document.querySelector('.posts-list').dataset.max;
        max_pages++;

        // console.log('--> ',current_page,max_pages);
        // console.log('initial Load= ','current_page ',current_page,' max_pages ',max_pages );

        //     // Initial load:
        // console.log('loading blog posts');
        Pace.loadBlogAjax( ajaxurl, {}, 'load_blog_posts', current_page, max_pages, '.posts-list', language );

        $(document).on('click', 'a.blog-filter', function(e) {

            $('button.load-more.blog-page').hide();
            // console.log( 'custom.js --> ',$(this).data('value') );

            current_page = 0;
            max_pages = 1;

            // console.log('Click --> ',current_page,max_pages);
            e.preventDefault();

            $('.blog-filter-dropdown').html( $(this).data('text-value') );

            $('.posts-list').html( 'Loading...' );

            blogFilterSet.categorie = $(this).data('value');

            Pace.loadBlogAjax( ajaxurl, blogFilterSet, 'load_blog_posts', current_page, max_pages, '.posts-list', language, false );

        });
    }

    // Load blog post for shortcode
    var blogDiv = $('.blog_loading_div');
    if ( blogDiv.length && typeof(blogDiv) != 'undefined' && blogDiv != null ) {

        var language = $("body").data('language') ? $("body").data('language') : 'de';

        current_page = document.querySelector('.posts-list').dataset.page;
        max_pages = document.querySelector('.posts-list').dataset.max;
        filter_cat = document.querySelector('.posts-list').dataset.filtercat;
        max_pages++;

        console.log('--> ',current_page,max_pages,filter_cat);

        // Loading:
        // console.log('loading blog posts');
        Pace.loadBlogAjax( ajaxurl, { 'categorie': filter_cat },'load_blog_posts', current_page, max_pages, '.posts-list', language );

    }    

    // Outlet opening times inject
    var outletOpeningData = $("#opening-times").data('openingTimes');
    if( JSON.stringify(outletOpeningData) !== '{}' ) {


        var outletAddress = $("div[data-inject='outlet-address']");
        if ( outletAddress.length && typeof(outletAddress) != 'undefined' && outletAddress != null ) 
        {
            $.each(outletAddress, function(i, val) 
            {
                var outlet = $(this).data('outlet');
                var id = $(this).attr('id');
                
                // console.log(outlet);

                var outlets = outletOpeningData.outlets;

                $.each(outlets, function(key, value) {
                    var content; 
                    if( value.key == outlet ) {
                        content = value.outletLocation ? value.outletLocation : '-';
                    }
                    $('#' + id).html(content);
                    return;
                });
            });
        }

        var outletOpenings = $("div[data-inject='outlet-opening']");

        if ( outletOpenings.length && typeof(outletOpenings) != 'undefined' && outletOpenings != null ) {
            
            $.each(outletOpenings, function(i, val) {

                var outlet = $(this).data('outlet');
                var length = $(this).data('length');
                var style = $(this).data('style');
                var language = $(this).data('language');
                var id = $(this).attr('id');

                // load data into
                // console.log('outletOpeningData: ', outletOpeningData);
                // console.log('attr.: ', outlet, length, style, language, id);

                // Select the proper outlet:
                var outlets = outletOpeningData.outlets;
                var outletFound = false;
                var content = '';
                $.each(outlets, function(key, value) {
                    // console.log(value.key);
                    if( value.key == outlet ) {

                        if( length == 'short' ) {
                            content = value['openingtext_' + language];
                        } else {
                            content = value['openingtext_lg_' + language];
                        }

                        var specialOpenings = value['special_openings'];
                        // console.log('specialOpenings: ', specialOpenings);
                        if( specialOpenings && specialOpenings.length ) {
                            // var count = 0;
                            $.each(specialOpenings, function(key, value) {
                                
                                // console.log('value: ', value);
                                var specialOpening = value;
                                content = content.concat('<span><strong>');
                                if( length == 'short' ) {
                                    content = content.concat('\n\r', '' + specialOpening['name_'+ language] + '');
                                } else {
                                    content = content.concat('\n\r', '' + specialOpening['description_'+ language] + '');
                                }                            
                                // Date formats
                                var from = new Date(specialOpening['from']);
                                var to = new Date(specialOpening['to']);
                                if( specialOpening['action'] == 'closed') {
                                    var options = {
                                        weekday: "short",
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "numeric"
                                    };
                                    from = from.toLocaleDateString(language, options);
                                    to = to.toLocaleDateString(language, options);
                                    // content = content.concat('<br>', from + ' – ' + to);
                                } else {
                                    var options = {
                                        weekday: "short",
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "numeric"
                                    };
                                    from = from.toLocaleDateString(language, options);
                                    to = to.toLocaleDateString(language, options);
                                    // content = content.concat('<br>', from + ' – ' + to);
                                }
                                content = content.concat('</strong></span>');
                                // console.log('loop: ', count++);
                                return false;
    
                            });

                         } else {
                            // console.log('nope');
                        }
                        $('#' + id).html(content);
                        outletFound = true;
                        return;
                    }
                });
                if( !outletFound ) $('#' + id).html( language=='de' ? 'Kein Outlet gefunden!' : 'Couldn\'t find an outlet!');
            });
        }

    }
    // URL with #borland shows Cookie-Consent from Borland
    var hash = window.location.hash;
    hash = hash.substring(1, hash.length);
    if (hash == 'borland') {
        $( '.show-cookie-consent' ).click ();
    }

    // Bewerber Zustimmung zu Consent / Smart recruiters
    var smartRecruitersCheckbox = $('a.smart-recruiters-check');
    if ( smartRecruitersCheckbox.length && typeof(smartRecruitersCheckbox) != 'undefined' && smartRecruitersCheckbox != null ) {


    }


});
